import React from 'react';

const CustomBreadcrumb = ({ breadcrumbs }) => {
  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        {breadcrumbs.map((breadcrumb, index) => {
          return (
            <li key={index} className={breadcrumb.active ? 'breadcrumb-item active' : 'breadcrumb-item'}>
              {breadcrumb.link ? <a href={breadcrumb.link}>{breadcrumb.name}</a> : breadcrumb.name}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}

export default CustomBreadcrumb;